export default __webpack_public_path__ + "static/media/barmen.55c044f1.svg";